import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AbstractTable } from './context/abstract/table.class';
import { getGlobalOrLocalCssVar } from 'projects/exi-ui/src/lib/utils/cssVarGetter.func';

export class Dom {
   public wrapper: HTMLDivElement;
   public header: HTMLDivElement;
   public body: HTMLDivElement;
   public shaper: HTMLDivElement;
   public host: HTMLDivElement;
   readonly isAlive = new BehaviorSubject(false);
   public sizes = {
      sizer: { 'height.px': 0 },
   }

   constructor(
      private ctx: AbstractTable<object>,
      readonly visibleCount: number,
   ) {
      this.init();
   }

   private init() {
      this.isAlive.pipe(
         filter(isAlive => isAlive)
      ).subscribe(() => {
         this.ctx.rows.height = getGlobalOrLocalCssVar('--exi-grid-row-height', this.wrapper);
         this.ctx.viewport.setHost(this.wrapper, this.ctx.rows.height, this.header.offsetHeight);
         this.host.style.maxHeight = this.wrapper.style.maxHeight;
         this.calibrateSizes();
      });
   }

   public calibrateSizes() {
      requestAnimationFrame(() => {
         this.sizes.sizer["height.px"] = this.wrapper.offsetHeight - 15;
      });
   }
}